module.exports = __webpack_public_path__ + "img/toggle-left.e4f339fe.svg";